function getDeliveryDate() {
  const daysOfWeek = ["Domingo", "Lunes", "Martes", "Miécoles", "Jueves", "Viernes", "Sábado"];
  const monthsOfYear = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
  //const today = new Date('Tue Jul 30 2024 12:11:40 GMT-0600');
  const today = new Date();
  const currentHour = today.getHours();
  const currentDay = today.getDay();

  let deliveryDate = new Date(today);

  if (currentDay === 5) { // Friday
    deliveryDate.setDate(today.getDate() + 3); // Next Monday
  } else if (currentDay === 6) { // Saturday
    deliveryDate.setDate(today.getDate() + 3); // Next Tuesday
  } else if (currentDay === 0) { // Sunday
    deliveryDate.setDate(today.getDate() + 2); // Next Tuesday
  } else if (currentDay >= 1 && currentDay <= 4 && currentHour < 15) { // Monday to Thursday before 3pm
    deliveryDate.setDate(today.getDate() + 1); // Next business day
  } else if (currentDay >= 1 && currentDay <= 4 && currentHour >= 15) { // Monday to Thursday after 3pm
    deliveryDate.setDate(today.getDate() + (currentDay === 4 ? 4 : 2)); // 2 business days or next Monday
  }

  const dayName = daysOfWeek[deliveryDate.getDay()];
  const monthName = monthsOfYear[deliveryDate.getMonth()];
  const day = deliveryDate.getDate();

  return `${dayName}, ${day} de ${monthName}`;
}

document.addEventListener('DOMContentLoaded', function() {
  const dateElement = document.getElementById('date__estimated');
  if (dateElement) {
    let date = getDeliveryDate();
    dateElement.textContent = date;
  }
});